import React from "react";
import { connect } from "react-redux";

import Box from "./Box";
import Row from "./Row";

import ManageRequirement from "../modal/ManageRequirement";
import Bool from "../../DataEntry/Bool";
import Currency from "../../DataEntry/Currency";
import Date from "../../DataEntry/Date";
import DateTime from "../../DataEntry/DateTime";
import Input from "../../DataEntry/Input";
import InputNumber from "../../DataEntry/InputNumber";

class Requirements extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
  }

  dataEntry = (data_type: string) => {
    switch (data_type) {
      case "boolean":
        return Bool;

      case "currency":
        return Currency;

      case "date":
        return Date;

      case "datetime":
        return DateTime;

      case "number":
        return InputNumber;

      default:
        return Input;
    }
  };

  onDestroy = (id: number) => {
    const { formik } = this.props;
    formik.setFieldValue(`requirement.${id}`, undefined);
  };

  render() {
    const {
      fields,
      formik: { isSubmitting },
      permissions,
      viewOnly,
    } = this.props;

    return (
      <Box title="Requirements">
        {fields.map((field: any) => (
          <Row
            key={field.id}
            name={`requirement.${field.id}`}
            label={field.title}
            component={this.dataEntry(field.data_type)}
            md={5}
            disabled={viewOnly || isSubmitting}
          />
        ))}

        <div className="row" style={{ paddingRight: "45px" }}>
          <div
            className="col-xs-12 text-right"
            style={{ padding: "10px  20px" }}
          >
            {permissions.location_manage_requirements && !viewOnly ? (
              <ManageRequirement onDestroy={this.onDestroy} />
            ) : (
              <a className="cursor-not-allowed">Manange</a>
            )}
          </div>
        </div>
      </Box>
    );
  }
}

const mapStateToProps = (state: any, _props: any) => ({
  fields: state.fields.data,
  permissions: state.permissions.data,
});

const mapDispatchToProps = (_dispatch: Function) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(Requirements);
